import { headerConstants } from './header.constants';

const initialState = { name: headerConstants.SET_HEADER_GREET, isActive: true, userInfo: {} };

function headerReducer(state = initialState, action) {
    switch (action.type) {
        case headerConstants.SET_HEADER:
            const { name, isActive } = action.payload;
            return {
                ...state,
                name: name,
                isActive: isActive,
                userInfo: action.payload.user
            };
        case headerConstants.SET_HEADER_GREET:
            return {
                name: action.payload.name,
                isActive: action.payload.isActive,
            };

        case headerConstants.RESET_HEADER:
            return {
                ...initialState
            };
        default:
            return state
    }
}

export { headerReducer };